import React, { useState } from 'react';
import './ContactForm.css'; // We will use the new CSS file
import { useNavigate } from 'react-router-dom';
import ContactImage from '../assets/gwh.jpg'; // This image will now be a background

export default function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // UNCHANGED: Form submission logic
  function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    fetch("https://formcarry.com/s/usj0t04MZVo", {
      method: 'POST',
      headers: { 
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ name, email, message })
    })
    .then(response => response.json())
    .then(response => {
      if (response.code === 200) {
        alert("We received your submission, thank you!");
        // Clear form after successful submission
        setName('');
        setEmail('');
        setMessage('');
        setError('');
      } else if (response.code === 422) {
        setError(response.message);
      } else {
        setError(response.message);
      }
    })
    .catch(error => {
      setError(error.message ? error.message : error);
    });
  }

  return (
    <div className="contact-page-wrapper">
      <button onClick={() => navigate('/')} className="back-button">
        &larr; Back to Home
      </button>

      <div className="contact-card">
        {/* Left Side - Info Panel */}
        <div className="info-section" style={{ backgroundImage: `url(${ContactImage})` }}>
          <div className="info-overlay">
            <h2>Get in Touch</h2>
            <p>We're here to help and answer any question you might have. We look forward to hearing from you!</p>
            <div className="contact-details">
              <p><strong>Address:</strong> 1/III, Malayadipatti Post, Rajapalayam,Virudhunagar District, India  - 626117</p>
              <p><strong>Email:</strong> sales@gowrihouse.com</p>
              <p><strong>Phone:</strong> +91-9344903116,+91-73587-61145,46,47 </p>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="form-section">
          <h3>Send us a Message</h3>
          <form onSubmit={onSubmit}>
            {error && <div className="error-message">{error}</div>}
            
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input 
                type="text" 
                value={name} 
                onChange={(e) => setName(e.target.value)} 
                id="name" 
                placeholder="Your Name" 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                id="email" 
                placeholder="yourmail@gmail.com" 
                required 
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Your Message</label>
              <textarea 
                value={message} 
                onChange={(e) => setMessage(e.target.value)} 
                id="message" 
                placeholder="Type your message here..." 
                rows="5"
                required
              ></textarea>
            </div>
            
            <button type="submit" className="submit-button">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  ); 
}